import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { MissingFormatRange } from "./internal/MissingFormat.js";
import { createNumberFormat, NumberAutoScaleFormat } from "./internal/NumberAutoScaleFormat.js";
/**
 * Proxy for {@link Intl.NumberFormat} that formats `null` and `undefined` as missing values.
 */ export var NumberMissingFormat = /*#__PURE__*/ function(MissingFormatRange) {
    "use strict";
    _inherits(NumberMissingFormat, MissingFormatRange);
    var _super = _create_super(NumberMissingFormat);
    function NumberMissingFormat(localesOrFormat, options) {
        _class_call_check(this, NumberMissingFormat);
        return _super.call(this, _instanceof(localesOrFormat, Intl.NumberFormat) || _instanceof(localesOrFormat, NumberAutoScaleFormat) ? localesOrFormat : createNumberFormat(localesOrFormat, options), options);
    }
    return NumberMissingFormat;
}(MissingFormatRange);

//# sourceMappingURL=NumberMissingFormat.js.map